'use client';

import {AccountRes} from '@epic-mw/types';
import useSWRImmutable from 'swr/immutable';
import {getAccount} from './account.fetch';
import {useAuth} from '../auth';

export interface UseAccountStoreProps {
	isMasked: boolean;
}

export const useAccountStore = (
	props?: UseAccountStoreProps
): {
	isLoading: boolean;
	isError?: string;
	account?: AccountRes;
} => {
	const authStore = useAuth();
	const shouldFetch = !!authStore.auth?.accountId && !!authStore.auth.isLoggedIn;
	const {data, error, isLoading} = useSWRImmutable(
		shouldFetch ? props || 'getAccount' : null,
		getAccount,
		{
			errorRetryCount: 1
		}
	);

	return {
		account: data,
		isLoading: shouldFetch ? isLoading && !data && !error : authStore.isLoading,
		isError: error
	};
};

export const useIsLoggedIn = (): boolean => useAccountStore().account?.isLoggedIn || false;

export const useAccountEmail = (): string => useAccountStore().account?.email || '';

export const useAccountDisplayName = (): string => useAccountStore().account?.displayName || '';

export const useAccountId = (): string => useAccountStore().account?.id || '';

export const useAccountCountry = (): string => useAccountStore().account?.country || '';
